/* eslint-disable */
import createIcon from '../createIcon';

const IconCaretDownOutlined = createIcon({
  name: 'icon-caret-down-outlined',
  content: '<title>树/收起箭头</title><g stroke-width="1" fill="none" fill-rule="evenodd"><polygon fill="currentColor" transform="translate(512.000000, 511.500000) rotate(-270.000000) translate(-512.000000, -511.500000) " points="349.5 255.5 349.5 767.5 674.5 511.5"/></g>',
  width: 1024,
  height: 1024
}, 'Icon');
export default IconCaretDownOutlined;
